export enum Medias {
  MD = 768,
  LG = 1024,
  XL = 1280
}
